import React, { FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import {
  GameInterface,
  GameInfo,
  PlayerResults,
  PlayersType,
  LatestResultsInterface
} from "../../../../redux/reducers/GameReducers";
import { connect, ConnectedProps } from "react-redux";
import { PlayersInterface } from "../PlayingGame";
import { MINIMUM_PLAYERS_TO_START_GAME } from "../../../../constants/game";
import {
  GOLD_COLOR,
  MODAL_SCORES_BG,
  MY_COLOR,
  CARD_MODAL_IMAGE_BG,
  MODAL_TITLE_COLOR
} from "../../../../constants/colors";
import PlayerWithScore from "./PlayerWithScore";
import ImageCardPicked from "./ImageCardPicked";

interface actionsType {}
interface RootState {
  game: GameInterface;
}

const actionsReducers: actionsType = {};

const mapStateToProps = (state: RootState) => ({
  game: state.game
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface ModalLatestResultProps {
  open: boolean;
  players: PlayersInterface;
  setOpenModalScores: (value: React.SetStateAction<boolean>) => void;
}

const ModalLatestResult: FunctionComponent<ModalLatestResultProps &
  PropsFromRedux> = (props) => {
  const latest_results = props.game.info?.latest_results;
  const handleClose = () => {
    props.setOpenModalScores(false);
  };
  const myPlayerId = props.game.myPlayerId as PlayersType;
  function renderScore() {
    let score;
    if (props.game.myPlayerId && latest_results) {
      score = latest_results[myPlayerId]?.score;
    } else {
      score = "...";
    }
    return (
      <div
        style={{
          padding: 20,
          marginTop: 20,
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "25px",
          color: GOLD_COLOR
        }}
      >
        Your score this round is {score}
      </div>
    );
  }
  function renderImage(url: string, playerId: PlayersType) {
    return (
      <ImageCardPicked
        isCorrect={playerId === latest_results?.player_speaker}
        isMe={playerId === props.game.myPlayerId}
        url={url}
        username={props.players[playerId].username}
      />
    );
  }
  function renderResults(info: GameInfo) {
    if (!latest_results) {
      return <div></div>;
    }
    const cloneLatestResults = {
      ...info.latest_results
    } as LatestResultsInterface;
    delete cloneLatestResults.concept;
    delete cloneLatestResults.player_speaker;
    delete cloneLatestResults.round;
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          overflow: "auto",
          justifyContent: "space-around"
        }}
      >
        {Object.keys(cloneLatestResults).map(
          (playerId_: any, index: number) => {
            console.log("props", props.game.myPlayerId);
            const player = (cloneLatestResults as any)[
              playerId_
            ] as PlayerResults;
            return (
              <div
                className={`ImageCardPicked ImageCardPickedShadow ${
                  playerId_ === myPlayerId ? "ImageCardPickedMyShadow" : ""
                }`}
                style={{
                  borderRadius: "10px 0px 10px 10px",
                  overflow: "auto",
                  padding: 10,
                  margin: 10,
                  textAlign: "center",
                  backgroundColor:
                    latest_results &&
                    playerId_ === latest_results.player_speaker
                      ? GOLD_COLOR
                      : playerId_ === myPlayerId
                      ? MY_COLOR
                      : CARD_MODAL_IMAGE_BG
                }}
                key={index}
              >
                {props.players[playerId_] &&
                  renderImage(player.imageUrl, playerId_)}
                <div>
                  <div>
                    {props.players &&
                      player.votesReceived?.map((playerId2, index) => {
                        if (props.players[playerId2] && latest_results) {
                          return (
                            <PlayerWithScore
                              key={index}
                              username={props.players[playerId2].username}
                              score={latest_results[playerId2]?.score}
                              isMe={playerId2 === myPlayerId}
                              isCorrect={
                                playerId_ === latest_results.player_speaker
                              }
                            />
                          );
                        }
                      })}
                  </div>
                </div>
              </div>
            );
          }
        )}
      </div>
    );
  }

  return (
    <Dialog
      fullScreen
      open={props.open}
      onClose={handleClose}
      TransitionComponent={Transition as any}
    >
      <div
        style={{
          backgroundColor: MODAL_SCORES_BG,
          position: "absolute",
          width: "100vw",
          height: "100vh",
          zIndex: 0
        }}
      ></div>
      <div
        style={{
          height: "calc(100vh - 70px)",
          overflow: "auto",
          zIndex: 1,
          textAlign: "center"
        }}
      >
        <h3 style={{ color: MODAL_TITLE_COLOR, marginTop: 10 }}>
          "{latest_results && latest_results.concept}"
        </h3>
        <h4 style={{ color: MODAL_TITLE_COLOR }}>
          Round {latest_results && latest_results.round}
        </h4>
        {props.game.info
          ? renderResults(props.game.info)
          : "Loading Results..."}
        <div>{renderScore()}</div>
      </div>
      <div>
        <Button
          className="buttonOkayScores"
          variant="contained"
          color="secondary"
          onClick={handleClose}
        >
          Okay!
        </Button>
      </div>
    </Dialog>
  );
};
export default connector(ModalLatestResult);
